import { 
  Box, 
  Drawer, 
  IconButton,
  Paper,
  Divider,
  Typography,
  Avatar,
  Stack,
  Chip,
  Fade,
  Zoom,
  Card,
  Button
} from '@mui/material';
// material
import { styled } from '@mui/material/styles';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
// components
import NavSection from '../NavSection';
// hooks
import useResponsive from '../useResponsive';
//
import {navConfigAdmin, navConfigAgent,navConfigProp} from './NavConfig';
import NavSectionDesktop from '../NavSectionDesktop';
import Logo from './Logo';
import Iconify from '../Iconify';
import { 
  Dashboard,
  Person,
  AdminPanelSettings,
  Business,
  AccountCircle
} from '@mui/icons-material';

const DRAWER_WIDTHOpen = '18%';
const DRAWER_WIDTHClose = '6%';

// ----------------------------------------------------------------------

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar, isOpenSidebarDesktop, onCloseSidebarDesktop }) {
  const { pathname } = useLocation();
  const [account, setAccount] = useState({});
  const isDesktop = useResponsive('up', 'lg');
const permission = JSON.parse(sessionStorage.getItem('user_details'))

  const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
      flexShrink: 0,
      width: isOpenSidebarDesktop ? DRAWER_WIDTHClose : DRAWER_WIDTHOpen,
    },
  }));

  const getRoleIcon = (userType, role) => {
    if (userType === 'admin' && role === 'Super Admin') {
      return <AdminPanelSettings sx={{ fontSize: 20, color: '#1976d2' }} />;
    } else if (userType === 'agent') {
      return <Person sx={{ fontSize: 20, color: '#1976d2' }} />;
    } else {
      return <Business sx={{ fontSize: 20, color: '#1976d2' }} />;
    }
  };

  const getRoleColor = (userType, role) => {
    if (userType === 'admin' && role === 'Super Admin') {
      return '#9c27b0';
    } else if (userType === 'agent') {
      return '#00bcd4';
    } else {
      return '#ff5722';
    }
  };

  const getRoleLabel = (userType, role) => {
    if (userType === 'admin' && role === 'Super Admin') {
      return 'Super Admin';
    } else if (userType === 'agent') {
      return 'Agent';
    } else {
      return 'Procurement';
    }
  };

  const getWhatsAppLink = (permission) => {
    console.log(permission);
    // Define role-based WhatsApp links
    if (permission.user_type === 'agent' && permission.role?.designation === 'Director') {
      return "https://chat.whatsapp.com/FrUBkKwyPXcDnD87SMxFlO?mode=wwt"
    } 

    return 'https://chat.whatsapp.com/J8mnMvOU1yo7EkzPjs24Co?mode=wwt';
  };

  const shouldShowWhatsAppBanner = (userType, role) => {
    // Show WhatsApp banner for all user types
    return userType === 'agent' || userType === 'admin' || userType === 'Procurement';
  };

  useMemo(()=> {
    // setAccount(JSON.parse(sessionStorage.getItem('user')))
  }, [])

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      {/* Professional Header Section */}
      <Fade in timeout={800}>
        <Paper
          elevation={0}
          sx={{
            background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
            borderRadius: 0,
            p: 2,
            m: 0,
            position: 'relative',
            overflow: 'hidden',
            minHeight: '80px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -20,
              right: -20,
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              zIndex: 0
            }}
          />
          <Stack direction="row" alignItems="center" justifyContent="center" sx={{ position: 'relative', zIndex: 1, width: '100%' }}>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                background: 'white',
                borderRadius: '8px',
                p: 1,
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                '& img': {
                  maxHeight: '50px',
                  width: 'auto'
                },
                '& svg': {
                  fontSize: '40px',
                  color: '#2c3e50'
                }
              }}
            >
              <Logo />
            </Box>
          </Stack>
        </Paper>
      </Fade>

      {/* User Profile Section */}
      {!isOpenSidebarDesktop && permission && (
        <Zoom in timeout={600}>
          <Box 
            sx={{ 
              p: 2, 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                background: 'rgba(255, 255, 255, 0.1)',
                transform: 'translateX(4px)'
              }
            }}
            onClick={() => {
              console.log('Profile clicked');
            }}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar
                sx={{
                  width: 36,
                  height: 36,
                  background: 'white',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
              >
                {getRoleIcon(permission?.user_type, permission?.role)}
              </Avatar>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.85rem'
                  }}
                >
                  {permission?.first_name+ ' ' + permission?.last_name || permission?.user_name || permission?.email || 'User'}
                </Typography>
                <Chip
                  label={getRoleLabel(permission?.user_type, permission?.role)}
                  size="small"
                  sx={{
                    background: getRoleColor(permission?.user_type, permission?.role),
                    color: 'white',
                    fontWeight: 500,
                    fontSize: '0.65rem',
                    height: 20,
                    mt: 0.5,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                  }}
                />
              </Box>
            </Stack>
          </Box>
        </Zoom>
      )}

      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }} />

      {/* Navigation Section */}
      <Box sx={{ 
        flexGrow: 1, 
        py: 1,
        overflow: 'auto',
        minHeight: 0, // Allows flex child to shrink below content size
        '&::-webkit-scrollbar': {
          width: '3px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '3px',
          '&:hover': {
            background: 'rgba(255, 255, 255, 0.5)',
          },
        },
      }}>
        {isOpenSidebarDesktop ? 
          <NavSectionDesktop navConfig={ permission?.user_type === 'agent' ? navConfigAgent : permission?.user_type === 'admin' && permission?.role === 'Super Admin' ? navConfigAdmin  : navConfigProp} /> :
          <NavSection navConfig={ permission?.user_type === 'agent' ? navConfigAgent : permission?.user_type === 'admin' && permission?.role === 'Super Admin' ? navConfigAdmin  : navConfigProp}  />
        }
      </Box>

      {/* WhatsApp Join Group Banner - Role Based */}
      {shouldShowWhatsAppBanner(permission?.user_type, permission?.role) && !isOpenSidebarDesktop && (
        <Fade in timeout={600}>
          <Box sx={{ px: 2, pb: 2 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                background: 'linear-gradient(135deg, #25D366, #128C7E)',
                color: 'white',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar
                  sx={{
                    bgcolor: 'white',
                    width: 40,
                    height: 40,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                  }}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    width="24"
                    height="24"
                  />
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle2" fontWeight="bold" color="white" sx={{ fontSize: '0.85rem' }}>
                    Join WhatsApp Community
                  </Typography>
                  <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '0.7rem' }}>
                    Stay connected with updates
                  </Typography>
                </Box>
              </Stack>
              <Button
                variant="contained"
                href={getWhatsAppLink(permission)}
                target="_blank"
                rel="noopener noreferrer"
                fullWidth
                sx={{
                  backgroundColor: 'white',
                  color: '#128C7E',
                  fontWeight: 'bold',
                  py: 0.75,
                  borderRadius: 1.5,
                  fontSize: '0.75rem',
                  '&:hover': {
                    backgroundColor: '#f1f1f1',
                    transform: 'scale(1.02)',
                  },
                  transition: 'all 0.2s ease-in-out',
                }}
                startIcon={<Iconify icon="mdi:whatsapp" width={16} height={16} />}
              >
                Join Group
              </Button>
            </Card>
          </Box>
        </Fade>
      )}

      {/* Professional Footer */}
      <Fade in timeout={1000}>
        <Box sx={{ p: 2, background: 'rgba(255, 255, 255, 0.05)', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
          {!isOpenSidebarDesktop && (
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
              <AccountCircle sx={{ fontSize: 16, color: 'rgba(255, 255, 255, 0.6)' }} />
              <Typography
                variant="caption"
                sx={{
                  color: 'rgba(255, 255, 255, 0.6)',
                  fontSize: '0.7rem',
                  fontWeight: 400
                }}
              >
                © 2024 Perfect Layout
              </Typography>
            </Stack>
          )}
        </Box>
      </Fade>
    </Box>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: {
              width: '70%',
              height: 'calc(100vh - 30px)', // Account for sticky header ad (30px)
              top: '30px', // Position below sticky header ad
              background: 'linear-gradient(180deg, #2c3e50 0%, #34495e 100%)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: isOpenSidebarDesktop ? DRAWER_WIDTHClose : DRAWER_WIDTHOpen,
              height: 'calc(100vh - 30px)', // Account for sticky header ad (30px)
              top: '30px', // Position below sticky header ad
              background: 'linear-gradient(180deg, #2c3e50 0%, #34495e 100%)',
              borderRight: 'none',
              boxShadow: '4px 0 20px rgba(0, 0, 0, 0.2)',
              transition: 'width 0.3s ease-in-out',
              overflow: 'hidden',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
